import { Injectable } from '@angular/core';
import { SearchResult } from './models/searchresult.model';
import { Subject } from 'rxjs';
import { AlternativeSearchesAvailable } from './models/alternativesearchesavailable.model';
import { SearchParams } from './models/searchParams.model';
import { DataError } from './models/dataerror.model';

@Injectable()
export class SearchService {
  searchResultsChanged = new Subject<SearchResult[]>();
  alternativeSearchesAvailableChanged = new Subject<AlternativeSearchesAvailable>();
  searchParamsChanged = new Subject<SearchParams>();
  dataErrorOccurred = new Subject<DataError>();
  isLoading = new Subject<boolean>();
  private searchResults: SearchResult[] = [];
  private alternativeSearchesAvailable: AlternativeSearchesAvailable = new AlternativeSearchesAvailable(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);
  constructor() { }
  clearResults() {
    this.searchResults = [];
    this.searchResultsChanged.next(this.searchResults.slice());
  }
  setSearchFields(params: SearchParams){
    this.searchParamsChanged.next(params);
  }
  setAlternativeSearchesAvailable(alternativeSearchesAvailable : AlternativeSearchesAvailable){
    this.alternativeSearchesAvailable = alternativeSearchesAvailable;
    this.alternativeSearchesAvailableChanged.next(this.alternativeSearchesAvailable);
  }
  setSearchResults(results: SearchResult[]){
    this.searchResults = results;
    this.searchResultsChanged.next(this.searchResults.slice());
  }
  setIsLoading(isLoading: boolean){
    this.isLoading.next(isLoading);
  }
  setDataError(error: DataError){
    this.clearResults();
    this.dataErrorOccurred.next(error);
  }
}
